import { render, staticRenderFns } from "./actes.vue?vue&type=template&id=c1e3532e&"
import script from "./actes.vue?vue&type=script&lang=js&"
export * from "./actes.vue?vue&type=script&lang=js&"
import style0 from "./actes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports